import React from 'react'
import {Route, Switch, withRouter} from 'react-router-dom'
import TransferOptions from './TransferOptions'
import Transfer from './Transfer'

const TransferRoutes = ({match: {path}}) =>(
  <Switch>
    <Route path={`${path}/transferFunds`} component={Transfer}/>
    <Route path={`${path}/transferSend`} component={Transfer}/>
    <Route path={`${path}/transferSpoa`} component={Transfer}/>
    <Route path={`${path}/transferIb`} component={Transfer}/>
    <Route path={`${path}`} component={TransferOptions}/>
  </Switch>
)

export default withRouter(TransferRoutes)
